import { useState } from 'react';
import { useTheme } from '../../../context/theme';
import { renderIcon } from '../../../utils/icons';
import { N } from '../../../utils/constants';
import SiteActivityFeed from './SiteActivityFeed';
import FinancialDashboardTab from './FinancialDashboardTab';
import VendorsTab from './VendorsTab';
import PurchaseOrdersTab from './PurchaseOrdersTab';
import AccountsPayableTab from './AccountsPayableTab';
import ReportsTab from './ReportsTab';

export default function SiteDetailTabs({ siteId, site, notes, documents, onAddNote, user, loadSite, workstreams: wsData }) {
  const { theme, isDark } = useTheme();
  const [tab, sT] = useState('activity2');

  const tabs = [
    { id: 'activity2', l: 'Activity', icon: 'activity' },
    { id: 'financial', l: 'Financial', icon: 'dollar-sign' },
    { id: 'vendors', l: 'Vendors', icon: 'users' },
    { id: 'pos', l: 'POs', icon: 'clipboard-list' },
    { id: 'ap', l: 'AP', icon: 'file-text' },
    { id: 'reports', l: 'Reports', icon: 'bar-chart' }
  ];

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12, overflowX: 'auto' }}>
        {tabs.map(t => (
          <button
            key={t.id}
            className="action-btn"
            onClick={() => sT(t.id)}
            style={{
              padding: '7px 16px',
              background: tab === t.id ? 'rgba(74,222,128,0.10)' : 'transparent',
              border: tab === t.id ? '1px solid rgba(74,222,128,0.20)' : '1px solid rgba(255,255,255,0.08)',
              borderRadius: 8,
              color: tab === t.id ? '#4ADE80' : 'rgba(255,255,255,0.55)',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: tab === t.id ? 600 : 400,
              fontFamily: "'DM Sans', sans-serif",
              whiteSpace: 'nowrap',
              display: 'flex', alignItems: 'center', gap: 6,
              transition: 'all 150ms ease-out',
            }}
          >
            {t.icon ? renderIcon(t.icon, 13, tab === t.id ? '#4ADE80' : 'rgba(255,255,255,0.40)') : null}
            {t.l}
          </button>
        ))}
      </div>
      {tab === 'activity2' && <SiteActivityFeed siteId={siteId} />}
      {tab === 'financial' && <FinancialDashboardTab siteId={siteId} site={site} user={user} />}
      {tab === 'vendors' && <VendorsTab siteId={siteId} site={site} user={user} />}
      {tab === 'pos' && <PurchaseOrdersTab siteId={siteId} site={site} user={user} />}
      {tab === 'ap' && <AccountsPayableTab siteId={siteId} site={site} user={user} />}
      {tab === 'reports' && <ReportsTab siteId={siteId} site={site} user={user} />}
    </div>
  );
}
